<template>
  <div class="search" :class="{ 'search--open': isOpen }">
    <button id="btn-search-close" class="btn btn--search-close" aria-label="Close search form" @click="closeSearch">
        <svg class="icon icon--cross" viewBox="0 0 24 24" width="48" height="48">
            <title>cross</title>
            <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill="white"></path>
        </svg>
    </button>
    <form class="search__form" @submit.prevent="handleSubmit">
      <input 
        class="search__input" 
        name="search" 
        type="search" 
        placeholder="Hledat v naší nabídce..." 
        autocomplete="off" 
        autocorrect="off" 
        autocapitalize="off" 
        spellcheck="false"
        v-model="searchQuery"
        ref="searchInput"
      />
      <span class="search__info">Pro vyhledávání stiskněte Enter, pro zavření ESC</span>
    </form>
  </div>
</template>

<script>
export default {
  name: 'SearchPopup',
  
  data() {
    return {
      isOpen: false,
      searchQuery: '',
      lastFocusedElement: null
    }
  },

  mounted() {
    document.addEventListener('keyup', this.handleKeyup)
  },

  beforeDestroy() {
    document.removeEventListener('keyup', this.handleKeyup)
  },

  methods: {
    openSearch() {
      this.lastFocusedElement = document.activeElement
      this.isOpen = true
      this.$nextTick(() => {
        this.$refs.searchInput.focus()
      })
    },

    closeSearch() {
      this.isOpen = false
      this.searchQuery = ''
      if (this.lastFocusedElement) {
        this.lastFocusedElement.focus()
      }
    },

    handleKeyup(e) {
      if (e.key === 'Escape') {
        this.closeSearch()
      }
    },

    handleSubmit() {
      if (this.searchQuery.trim()) {
        // Redirect to search results page with query parameter
        window.location.href = `/search/results?q=${encodeURIComponent(this.searchQuery.trim())}`;
      }
    }
  }
}
</script> 